import { ExamsPicker } from "src/components/NewComponents/Creator/ContentPicker/ExamsPicker";

import { LayoutWithSearch } from "src/containers/Layouts/LayoutWithSearch";

function ExamsPickerContainer() {
	return (
		<LayoutWithSearch>
			<ExamsPicker />
		</LayoutWithSearch>
	);
}

export default ExamsPickerContainer;
